import axios from 'axios'

let baseUrl = window.location.host
let baseUrlDrupal = window.location.host
let localhost = false


if (baseUrl == "localhost:8080" || baseUrl == "2haffit.server2.voatt.cz") {
    baseUrl = 'https://2haffitapi.server2.voatt.cz'
    baseUrlDrupal = 'https://2haffit.server2.voatt.cz'
    localhost = true
} else {
    baseUrl = '//api.pettime.cz'
    baseUrlDrupal = '//www.pettime.cz'
}

//Silex framework
export const apiSilex = axios.create({
    baseURL: baseUrl + '/cs',
    timeout: 50000,
    headers: {
	    'Content-Type': 'application/json'
    }
})

//Drupal
export const apiDrupal = axios.create({
    baseURL: baseUrlDrupal + '/api/cs',
    timeout: localhost ? 50000 : null, //NOTE: For localhost
    //withCredentials: true,
    auth: {
	username: '2haffit',
	password: '2haffit'
    },
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Basic ZnV0YWxpczpmdXRhbGlz'
    }
})



// WEBPACK FOOTER //
// ./src/api/index.js